// src/api/restaurant.api.ts

import { get, post, put, del, patch, uploadPut } from './client';
import {
  ApiResponse,
  PaginatedResponse,
  Restaurant,
  CreateRestaurantDto,
  UpdateRestaurantDto,
  UpdateRestaurantProfileDto,
  RestaurantQueryParams,
  DashboardStatistics,
} from '../types';

export const restaurantApi = {
  // Admin endpoints
  createRestaurant: (data: CreateRestaurantDto) => {
    return post<ApiResponse<{ restaurant: Restaurant; user: any }>>('/restaurants', data);
  },

  getAllRestaurants: (params?: RestaurantQueryParams) => {
    return get<PaginatedResponse<Restaurant>>('/restaurants', { params });
  },

  getRestaurantById: (id: string) => {
    return get<ApiResponse<Restaurant>>(`/restaurants/${id}`); // 👈 إصلاح
  },

  updateRestaurant: (id: string, data: UpdateRestaurantDto) => {
    return put<ApiResponse<Restaurant>>(`/restaurants/${id}`, data); // 👈 إصلاح
  },

  deleteRestaurant: (id: string) => {
    return del<ApiResponse>(`/restaurants/${id}`); // 👈 إصلاح
  },

  resetRestaurantData: (id: string) => {
    return post<ApiResponse>(`/restaurants/${id}/reset`);
  },

  // Owner endpoints
  getMyProfile: () => {
    return get<ApiResponse<Restaurant>>('/restaurants/my/profile');
  },

  getDashboardSummary: () => {
    return get<ApiResponse<{
      restaurant: Restaurant;
      totalCategories: number;
      totalDishes: number;
      availableDishes: number;
      totalTables: number;
    }>>('/restaurants/my/dashboard-summary');
  },

  // 👇 Dashboard Statistics with Filters
  getDashboardStatistics: (filters?: {
    period?: 'today' | 'week' | 'month' | 'year' | 'custom';
    startDate?: string;
    endDate?: string;
  }) => {
    return get<ApiResponse<DashboardStatistics>>(
      '/orders/restaurant/dashboard-statistics',
      { params: filters }
    );
  },

  updateMyProfile: (data: UpdateRestaurantProfileDto) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === 'socialLinks' || key === 'phoneNumbers' || key === 'customThemeColors') {
          formData.append(key, JSON.stringify(value));
        } else if ((key === 'logo' || key === 'backgroundImage') && value instanceof File) {
          formData.append(key, value);
        } else if (!(value instanceof File)) {
          formData.append(key, value.toString());
        }
      }
    });

    return uploadPut<ApiResponse<Restaurant>>('/restaurants/my/profile', formData);
  },

  // Toggle accepting orders
  toggleAcceptingOrders: (isAcceptingOrders: boolean) => {
    return patch<ApiResponse<Restaurant>>('/restaurants/my/accepting-orders', { isAcceptingOrders });
  },

  // Public endpoint
  getPublicMenu: (slug: string) => {
    return get<ApiResponse<Restaurant>>(`/menu/${slug}`); // 👈 إصلاح
  },
};